import type { TUpdatePasswordElement } from '@shared/dream-components';
import { UpdatePasswordElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

import UpdatePasswordAction from '~/components/UpdatePasswordAction';

interface Props {
  node: TUpdatePasswordElement;
  children: ReactNode | ReactNode[];
}

const UpdatePassword = ({ node, children }: Props) => {
  return (
    <UpdatePasswordAction>
      {({ isLoading }) => (
        <UpdatePasswordElement element={node} isSubmitting={isLoading}>
          {children}
        </UpdatePasswordElement>
      )}
    </UpdatePasswordAction>
  );
};

export default UpdatePassword;
